import BottomNavigation from "@mui/material/BottomNavigation/BottomNavigation"
import BottomNavigationAction from "@mui/material/BottomNavigationAction/BottomNavigationAction"
import Icon from "@mui/material/Icon/Icon"
import Paper from "@mui/material/Paper/Paper"
import { ballotPath, pollMapPath, pollResultsPath } from "./route"

const actions = ["ballot", "results", "map"]

export function PollNavigation(props: { nav: string; pollID: string }) {
  return (
    <Paper elevation={10}>
      <BottomNavigation value={actions.indexOf(props.nav)} showLabels>
        <BottomNavigationAction
          href={ballotPath(props.pollID)}
          label="My Ballot"
          icon={<Icon children="ballot" />}
        />
        <BottomNavigationAction
          href={pollResultsPath(props.pollID)}
          label="Results"
          icon={<Icon children="gavel" />}
        />
        <BottomNavigationAction
          href={pollMapPath(props.pollID)}
          label="Map"
          icon={<Icon children="map" />}
        />
      </BottomNavigation>
    </Paper>
  )
}
